// all images taken from https://www.pexels.com/search/real%20estate/

import image2 from "./files/2.jpeg";
import image7 from "./files/7.jpeg";
import image10 from "./files/10.jpeg";
import image13 from "./files/13.jpeg";
import image18 from "./files/18.jpeg";
import image21 from "./files/21.jpeg";
import image27 from "./files/27.jpeg";
import image28 from "./files/28.jpeg";
import image29 from "./files/29.jpeg";

export const images = [
  [image2, "50% 80%"],
  [image7, `50% 76%`],
  [image10, `50% 50%`],
  [image13, `50% 50%`],
  [image18, `50% 60%`],
  [image21, `50% 70%`],
  [image27, `50% 60%`],
  [image28, `50% 23%`],
  [image29, `50% 50%`]
];



// WEBPACK FOOTER //
// ./src/images/index.js